import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BrandData {
  brandId: string;
  brandName: string;
}

interface StoreData {
  internalId: string;
  id?: string;
  storeAddress: string;
  storeAlias: string;
  modeOfOperation: string[];
  availableBrands: BrandData[];
  storePoc: string;
  openTime: string;
  closeTime: string;
}

interface StoreState {
  stores: StoreData[];
  expandedStore: string;
  errors: Record<string, string>;
  status: {
    isComplete: boolean;
    hasError: boolean;
  };
}

const initialState: StoreState = {
  stores: [
    {
      id: 'Store 1',
      internalId: '1',
      storeAddress: '',
      storeAlias: '',
      modeOfOperation: [],
      availableBrands: [],
      storePoc: '',
      openTime: '',
      closeTime: '',
    },
  ],
  expandedStore: '1',
  errors: {},
  status: {
    isComplete: false,
    hasError: false,
  },
};

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    addStore: state => {
      const newStoreNumber = state.stores.length + 1;
      const newInternalId = newStoreNumber.toString();
      const newStoreName = `Store ${newStoreNumber}`;

      state.stores.push({
        id: newStoreName,
        internalId: newInternalId,
        storeAddress: '',
        storeAlias: '',
        modeOfOperation: [],
        availableBrands: [],
        storePoc: '',
        openTime: '',
        closeTime: '',
      });
      state.expandedStore = newInternalId;
    },
    updateStore: (
      state,
      action: PayloadAction<{
        storeId: string;
        field: keyof StoreData;
        value: any;
      }>
    ) => {
      const { storeId, field, value } = action.payload;
      const storeIndex = state.stores.findIndex(
        store => store.internalId === storeId
      );
      if (storeIndex !== -1) {
        state.stores[storeIndex] = {
          ...state.stores[storeIndex],
          [field]: value,
        };
      }
    },
    setExpandedStore: (state, action: PayloadAction<string>) => {
      state.expandedStore = action.payload;
    },
    resetStores: state => {
      state.stores = initialState.stores;
      state.expandedStore = initialState.expandedStore;
    },
    setStoreStatus: (
      state,
      action: PayloadAction<{ isComplete: boolean; hasError: boolean }>
    ) => {
      state.status = action.payload;
    },
    setStoreErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
  },
});

export const {
  addStore,
  updateStore,
  setExpandedStore,
  resetStores,
  setStoreStatus,
  setStoreErrors,
} = storeSlice.actions;
export default storeSlice.reducer;
